import { render } from "./IntakeFormModal.vue?vue&type=template&id=2142e542"
import script from "./IntakeFormModal.vue?vue&type=script&lang=js"
export * from "./IntakeFormModal.vue?vue&type=script&lang=js"

import "./IntakeFormModal.vue?vue&type=style&index=0&id=2142e542&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__